export default __webpack_public_path__ + "static/media/camera.d8d765f7.svg";